import { createSHA256 } from 'hash-wasm';

export { createSHA256 };

export async function hashApplicationBlob(blob, { signal, onProgress = () => {} } = {}) {
  const hash = await createSHA256();
  hash.init();
  const step = 2 * 1024 * 1024;
  for (let offset = 0; offset < blob.size; offset += step) {
    if (signal?.aborted) throw new DOMException('Opération annulée', 'AbortError');
    hash.update(new Uint8Array(await blob.slice(offset, offset + step).arrayBuffer()));
    onProgress(Math.round(Math.min(offset + step, blob.size) / blob.size * 100));
    // Laisser les commandes d'annulation et la progression se mettre à jour.
    await new Promise(resolve => setTimeout(resolve, 0));
  }
  if (signal?.aborted) throw new DOMException('Opération annulée', 'AbortError');
  return hash.digest('hex');
}
